import React from 'react';
import { Competition } from '../../types/interfaces';
import { CompetitionPermissions } from '../../services/manageApi';
import CountdownSettings from './CountdownSettings';
import DetailsForm from './DetailsForm';
import LogoField from './LogoField';
import MarkdownContentSection from './MarkdownContentSection';

interface Props {
  competition: Competition;
  permissions: CompetitionPermissions;
  canEdit: (field: string) => boolean;
  onCompetitionUpdated: (competition: Competition) => void;
  onDirtyChange: (section: string, dirty: boolean) => void;
}

const ContentTab: React.FC<Props> = ({ competition, permissions, canEdit, onCompetitionUpdated, onDirtyChange }) => (
  <>
    <DetailsForm
      competition={competition}
      permissions={permissions}
      canEdit={canEdit}
      onSaved={onCompetitionUpdated}
      onDirtyChange={onDirtyChange}
    />
    <CountdownSettings
      competitionId={competition.id}
      canEdit={canEdit('countdown_enabled')}
      requiredRole={permissions.field_min_role.countdown_enabled}
      onDirtyChange={onDirtyChange}
    />
    <section className="manage-section" data-tour="manage-logo">
      <h3>Logo</h3>
      <LogoField
        competition={competition}
        canEdit={canEdit('logo')}
        requiredRole={permissions.field_min_role.logo}
        onUploaded={(url) => onCompetitionUpdated({ ...competition, logo_path: url })}
      />
    </section>
    <MarkdownContentSection
      competitionId={competition.id}
      kind="readme"
      title="Instructions"
      help="The Readme participants see on the competition page."
      canEdit={canEdit('instructions')}
      requiredRole={permissions.field_min_role.instructions}
      onDirtyChange={onDirtyChange}
      onSaved={(content) => onCompetitionUpdated({ ...competition, instructions_path: content.public_url || competition.instructions_path })}
    />
    <MarkdownContentSection
      competitionId={competition.id}
      kind="evaluation"
      title="Judge instructions"
      help="Shown to judges in the collapsible “Evaluation instructions” panel on the judging page."
      canEdit={canEdit('evaluation_instructions')}
      requiredRole={permissions.field_min_role.evaluation_instructions}
      onDirtyChange={onDirtyChange}
      onSaved={(content) => onCompetitionUpdated({ ...competition, evaluation_path: content.public_url || competition.evaluation_path })}
    />
  </>
);

export default ContentTab;
